import { Box, Typography } from '@mui/material';
import { ROSTER } from '../tokens';
import { bylineOf, lastSeenLine } from '../profileText';
import type { StudentProfile } from '../studentProfileApi';

const lineSx = { m: 0, fontFamily: ROSTER.font, fontSize: 16, lineHeight: '24px', color: ROSTER.muted } as const;

export function ProfileHeader({ profile }: { profile: StudentProfile }) {
  const { student, standing } = profile;
  const name = `${student.firstName ?? ''} ${student.lastName ?? ''}`.trim() || `Student ${student.id}`;
  const byline = bylineOf({ grade: student.grade ?? '', school: student.school ?? '', elTeachers: student.elTeachers }, standing);
  return (
    <Box component="header" sx={{ display: 'flex', flexDirection: 'column', gap: '8px', pb: '8px' }}>
      <Typography component="h1" sx={{ m: 0, fontFamily: ROSTER.font, fontSize: 28, fontWeight: 600, lineHeight: '36px', color: ROSTER.ink }}>
        {name}
      </Typography>
      <Typography sx={lineSx}>{byline}</Typography>
      {standing === 'departed' && profile.lastSeenSchoolYearEnd != null && <Typography sx={lineSx}>{lastSeenLine(profile.lastSeenSchoolYearEnd)}</Typography>}
    </Box>
  );
}
